import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCurrencyInput from 'vue-currency-input'
Vue.use(VueCurrencyInput)

import Vue2TouchEvents from 'vue2-touch-events'
Vue.use(Vue2TouchEvents);

import FBSignInButton from 'vue-facebook-signin-button/index.js';
Vue.use(FBSignInButton);

Vue.config.productionTip = false;

window["BookingPortal"] = new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')

// check if an element exists in array using a comparer function
// comparer : function(currentElement)
Array.prototype.inArray = function(comparer) {
    for(var i=0; i < this.length; i++) {
        if(comparer(this[i])) return true;
    }
    return false;
};

// adds an element to the array if it does not already exist using a comparer
// function
Array.prototype.pushIfNotExist = function(element, comparer) {
    if (!this.inArray(comparer)) {
        this.push(element);
        return true;
    } else return false;
};
